import fetchItemPolicyBudget from 'actions/businessTraveller/fetchItemPolicyBudget'
import type { FetchItemPolicyBudgetParams } from 'businessTraveller/types/itemPolicyBudget.types'
import { useAppDispatch } from 'hooks/reduxHooks'
import { useEffect } from 'react'

type Params = FetchItemPolicyBudgetParams & {
  enabled?: boolean
}

/**
 * Loads item-policy budgets via GET …/item-policies/budgets (hotel, flight, or car hire budget search).
 */
function useFetchItemPolicyBudget(params: Params): void {
  const {
    enabled = true,
    cacheKey,
    businessId,
    employeeIds,
  } = params
  const employeeIdsKey = employeeIds.join(',')
  const appDispatch = useAppDispatch()

  useEffect(() => {
    const { enabled: _enabled, ...fetchParams } = params
    const hasValidBudgetQueryContext =
      fetchParams.itemPolicyType === 'CAR_HIRE'
        ? fetchParams.numberOfDays >= 1 && fetchParams.travellerCount >= 1
        : fetchParams.itemPolicyType === 'FLIGHT'
          ? !!(fetchParams.departingAirportCode && fetchParams.arrivingAirportCode)
          : !!(fetchParams.lePlaceId || (fetchParams.latitude && fetchParams.longitude))

    if (
      !enabled ||
      !fetchParams.businessId ||
      !fetchParams.cacheKey ||
      !hasValidBudgetQueryContext ||
      fetchParams.employeeIds.length === 0
    ) {
      return
    }

    appDispatch(fetchItemPolicyBudget(fetchParams))
    // cacheKey encodes semantic request identity; callers must regenerate it when any query input changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- avoid re-running on new `params` object identity each render
  }, [appDispatch, enabled, cacheKey, businessId, employeeIdsKey])
}

export default useFetchItemPolicyBudget
